<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Employee</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Learning</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/job/index">Manage Jobs</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Create</span
        >
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-2">
          
        </div>
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="createJob">
              <div v-if="message" class="alert alert-success py-2">
                {{ message }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger py-2">
                {{ errorMessage }}
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Job Title <span class="text-danger">*</span></label
                  ><select
                    v-model="selectedJobId"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    required
                    @change="selectJob"
                  >
                    <option value="">Select Job Title</option>
                    <option v-for="job in jobs" :key="job.id" :value="job.id">
                      {{ job.job_title }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Add People <span class="text-danger">*</span></label
                  ><select
                    v-model="selectedEmployee"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    required
                  >
                    <option value="">Select People</option>
                    <option
                      v-for="employee in employees"
                      :key="employee.id"
                      :value="employee.id"
                    >
                      {{ employee.label }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="custom-label" style="font-size: small"
                    >Job Description</label
                  ><textarea
                    v-model="jobDescription"
                    class="form-control form-control-sm bdr-rad font-size_def"
                    rows="2"
                    readonly
                  ></textarea>
                </div>
              </div>
              
              <div class="card custom_bdr_rds">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Job Files and Links</b></h6>
                  <div class="table-responsive mb-1">
                    <table
                      style="font-size: small"
                      class="table table-sm table-hover"
                    >
                      <thead class="background_color2">
                        <tr class="custom-label2">
                          <th style="width: 50px">#</th>
                          <th>File Upload</th>
                          <th>Links</th>
                          <th style="width: 50px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in rows" :key="row.key">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <a
                              v-if="row.existingFileUrl"
                              :href="row.existingFileUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="d-inline-block mb-1 small text-primary"
                            >
                              {{ fileName(row.existingFile) }}
                            </a>
                            <input
                              type="file"
                              class="form-control form-control-sm bdr-rad font-size_def"
                              @change="setFile($event, row)"
                            />
                          </td>
                          <td>
                            <input
                              v-model="row.link"
                              type="url"
                              class="form-control form-control-sm bdr-rad"
                            />
                          </td>
                          <td class="text-nowrap custom-icon">
                            <b-icon
                              v-if="row.isNew"
                              @click="removeRow(index)"
                              v-show="rows.length > 1"
                              class="ms-3 me-3 mt-2"
                              width="8"
                              type="button"
                              icon="dash-lg"
                              scale="2"
                              variant=""
                            ></b-icon
                            ><b-icon
                              v-if="row.isNew && index === rows.length - 1"
                              @click="addRow"
                              class="mt-2"
                              width="8"
                              type="button"
                              icon="plus-lg"
                              scale="2"
                              variant=""
                            ></b-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button type="submit" class="btn btn-sm btn-outline-primary bdr-rad font-size_def">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <br><br
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      jobs: [],
      employees: [],
      selectedJobId: "",
      selectedEmployee: "",
      jobDescription: "",
      rows: [],
      message: "",
      errorMessage: "",
    };
  },
  mounted() {
    this.loadJobs();
    this.loadEmployees();
  },
  methods: {
    newRow() {
      return {
        key: Date.now() + Math.random(),
        detail_id: "",
        file: null,
        existingFile: "",
        existingFileUrl: "",
        link: "",
        isNew: true,
      };
    },
    async loadJobs() {
      try {
        const { data } = await axios.get("/ticourses/jobs", {
          headers: { Authorization: "Bearer " + this.token },
        });
        this.jobs = data.data || [];
        this.rows = [this.newRow()];
      } catch (error) {
        this.errorMessage = "Unable to load jobs.";
      }
    },
    async loadEmployees() {
      try {
        const { data } = await axios.get(
          "/ticourses/employee-training-requirements",
          { headers: { Authorization: "Bearer " + this.token } }
        );
        const seen = {};
        this.employees = (data.data || [])
          .filter((item) => {
            const key = item.fin_nric || item.id;
            if (seen[key]) return false;
            seen[key] = true;
            return true;
          })
          .map((item) => ({
            id: item.id,
            label: (item.fin_nric ? item.fin_nric + " - " : "") + item.name,
          }));
      } catch (error) {
        this.errorMessage = "Unable to load employees.";
      }
    },
    selectJob() {
      const job = this.jobs.find(
        (item) => Number(item.id) === Number(this.selectedJobId)
      );
      this.jobDescription = job ? job.job_description || "" : "";
      this.rows =
        job && job.details && job.details.length
          ? job.details
              .map((detail) => ({
                key: "detail-" + detail.id,
                detail_id: detail.id,
                file: null,
                existingFile: detail.file || "",
                existingFileUrl: detail.file_url || detail.file || "",
                link: detail.link || "",
                isNew: false,
              }))
              .concat([this.newRow()])
          : [this.newRow()];
    },
    addRow() {
      this.rows.push(this.newRow());
    },
    removeRow(index) {
      if (this.rows.length > 1) this.rows.splice(index, 1);
    },
    setFile(event, row) {
      row.file = event.target.files[0] || null;
    },
    fileName(file) {
      return file ? String(file).split("/").pop() : "Uploaded file";
    },
    async createJob() {
      if (!this.selectedJobId || !this.selectedEmployee) {
        this.errorMessage = "Job Title and Employee are required.";
        return;
      }
      const formData = new FormData();
      formData.append(
        "payload",
        JSON.stringify({
          mode: "assignment",
          job_id: this.selectedJobId,
          employee_id: this.selectedEmployee,
          details: this.rows.map((row) => ({
            detail_id: row.detail_id,
            link: row.link,
          })),
        })
      );
      this.rows.forEach((row, index) => {
        if (row.file)
          formData.append("assignment_files[" + index + "]", row.file);
      });
      try {
        const { data } = await axios.post("/ticourses/create-jobs", formData, {
          headers: { Authorization: "Bearer " + this.token },
        });
        this.message = data.message || "Job assigned successfully.";
        this.errorMessage = "";
        this.rows = [this.newRow()];
         setTimeout(() => this.$router.push("/job/index"), 500);
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Unable to assign job.";
      }
    },
    goBack() {
      this.$router.push("/job/descreate");
    },
  },
};
</script>
